import React, { useState, useMemo, useCallback, useEffect } from 'react';
import MaterialTable, { MTableBody } from 'material-table';
import { Tooltip, Typography, withStyles, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { BackButton, localization, hasPermission } from '../../sc-utilities';
import DataRange from '../../sc-utilities/DateRange';
import * as actions from './store/productOverviewActions';
import { connect } from 'react-redux';
import * as Yup from "yup";
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import TableView from './TableView';
import { Redirect } from 'react-router-dom';
import {
    filterQuery, listStyle, createOrderQuery,
    //  createOrAppendUrl
} from './utils';
import Export from "../../sc-components/ExportForm";

const styles = theme => (listStyle);
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

// Include PDF LATER
let initialValues = [
    'Excel',
    'JSON',
    'CSV',
    'XML',
    'Download',
    "Email",
    "includePDFReports",
    "includeDiagnoseReports",
    "includeVerificationReports",
    "includeAggregatedPDFErasureReports",
    "includeAggregatedPDFVerificationReports",
    "includeSummaryPDFErasureReports",
    "includeSummaryPDFVerificationReports",
];

const route = 'filtered';

const CustomTableBody = (props) => {
    const { bodyProps, filterValues, tableRef } = props;

    return (
        <MTableBody {...bodyProps} onFilterChanged={(columnId, value) => {
            if (filterValues) {
                filterValues.current = ({ fromEnter: false, q: { ...filterValues.current?.q, [tableRef?.current?.props?.columns[columnId]?.field]: value } });
            }
            bodyProps.onFilterChanged(columnId, value);
        }} />
    )
}

const ProductOverviewList = props => {
    const { filterValues, focusedInputRef, updateView, classes, translations, setQuery, hideViewSelector, allQuery, currentView, permissions, tableRef, redirectOptions, activeCustomerID, tableColumns, fetchProductOverviewDataCount, fetchProductOverviewData, groupsLookup, groups } = props;

    const columnObject = useMemo(() => tableColumns, [tableColumns]);
    const [edited, setEdited] = useState(true);
    const componentHeight = hideViewSelector ? 258 : 335;

    const [table, setTable] = useState({ data: [], page: 0, pageSize: 0, totalCount: 0 });

    const [dateRangeValue, setDateRangeValue] = useState(null);

    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: true,
        thirdSortClick: false,
        debounceInterval: 5000,
        search: false,
        filterCellStyle: { maxWidth: '150px' },
        minBodyHeight: window.innerHeight - componentHeight < 300 ? 300 : window.innerHeight - componentHeight,
        maxBodyHeight: window.innerHeight - componentHeight,
        pageSizeOptions: rowsPageSizeInit,
        columnsButton: true,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
        },
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    })

    useEffect(() => {
        const customerTimezone = window.localStorage.getItem("CustomerTimezone") ?? 'UTC';

        const from = momentTimezone.tz(moment(), customerTimezone);
        
        setDateRangeValue({
            From: from,
            To: from,
            maxDate: from.set({
                hours: 23,
                minutes: 59,
                seconds: 59,
            })
        });

        const handleEvent = (event) => {
            if (event.key === 'Enter') {
                filterValues.current = { ...filterValues.current, fromEnter: true, refetch: true };
                tableRef.current && tableRef.current.onQueryChange();
            }
        };
        window.addEventListener('keydown', handleEvent);
        return () => window.removeEventListener('keydown', handleEvent);
        // eslint-disable-next-line
    }, [ activeCustomerID ]);

    //  ---------------- URL QUERY----------------------------
    // const createFilterUrl = useCallback(async (query) => {
    //     if (query && query.q && tableRef?.current?.dataManager?.columns) {

    //         let columns = tableRef?.current?.dataManager?.columns;
    //         const index = (value) => columns.findIndex(el => el?.field === value);
    //         const columnFilter = (value) => columns[index(value)]?.tableData?.filterValue;

    //         const objForUrl = {
    //             WipeStarted: columnFilter('WipeStarted') ?? null,
    //             OrderInventoryID: columnFilter('OrderInventoryID') ?? null,
    //             TransportColliInventoryID: columnFilter('TransportColliInventoryID') ?? null,
    //             ColliInventoryID: columnFilter('ColliInventoryID') ?? null,
    //             InventoryID: columnFilter('InventoryID') ?? null,
    //             Vendor: columnFilter('Vendor') ?? null,
    //             Model: columnFilter('Model') ?? null,
    //             ProductType: columnFilter('ProductType') ?? null,
    //             WipeStatus: columnFilter('WipeStatus') ?? null,
    //             orderBy: tableRef?.current?.dataManager?.orderBy ?? null,
    //             orderDirection: query?.orderDirection ?? 'asc',
    //             SerialNumber: columnFilter('SerialNumber') ?? null,
    //             TableViewID: query?.TableViewID ?? null,
    //         };
    //         await createOrAppendUrl(objForUrl);
    //     };
    // }, [tableRef]);

    const fetchTableData = useCallback(async (query) => {
        if (filterValues.current?.refetch === false) {
            return table;
        }
        if (!tableRef?.current?.customTableViewSetup?.selectedTableView) {
            return { data: [], page: 0, pageSize: 0, totalCount: 0 };
        }

        tableRef.current.state.query = query;
        const q = filterQuery(query?.filters || []);
        query['ActiveCustomerID'] = activeCustomerID;
        query['From'] = dateRangeValue?.From.format('YYYY-MM-DD');
        query['To'] = dateRangeValue?.To.format('YYYY-MM-DD');

        query['q'] = (hideViewSelector && allQuery && Object.keys(allQuery?.q).length > 1) ? allQuery?.q : q;
        if (q.GroupID && q.GroupID.length === 0) {
            delete q["GroupID"];
        }
        let columns = tableRef?.current?.state?.columns ?? [];

        query['orders'] = query?.orderBy?.field ? createOrderQuery(query?.orderBy?.field, tableRef?.current?.dataManager?.orderDirection ?? 'asc') : [];

        query['QueryTypeKey'] = 'ProductsAll';
        query['TableViewID'] = tableRef?.current?.customTableViewSetup?.selectedTableView;

        if (hideViewSelector && allQuery && tableRef.current.dataManager.orderBy) {
            let orderedColumnId = columns[allQuery?.orderBy];
            allQuery['ActiveCustomerID'] = activeCustomerID;
            allQuery['From'] = dateRangeValue && dateRangeValue?.From.format('YYYY-MM-DD');
            allQuery['QueryTypeKey'] = 'ProductsAll';
            if (allQuery['orderDirection'] !== 'asc' || allQuery?.orderDirection !== 'desc') {
                allQuery['orderDirection'] = 'asc'
            }
            allQuery['To'] = dateRangeValue && dateRangeValue?.To.format('YYYY-MM-DD');
            if (orderedColumnId?.field && allQuery?.orderBy) {

                allQuery['orders'] = (orderedColumnId?.field && createOrderQuery(orderedColumnId?.field, allQuery?.orderDirection ?? 'asc')) ?? [];
                tableRef.current.dataManager.orderBy = typeof allQuery?.orderBy === 'object' ? allQuery?.orderBy?.tableData?.columnOrder : allQuery?.orderBy;
                tableRef.current.dataManager.orderDirection = allQuery?.orderDirection;
            }
        }

        let filters = { ...query, q: { ...query.q, ...filterValues.current?.q } };
        filters.q = Object.keys(filters.q ?? {}).reduce((acc, filterKey) => filters.q[filterKey] !== null ? { ...acc, [filterKey]: filters.q[filterKey] } : acc, {})

        const count = (!query.TableViewID && query && Object.keys(query?.q).length === 0) || (!allQuery?.QueryTypeKey && allQuery && Object.keys(allQuery?.q).length === 0) ? 0 : await fetchProductOverviewDataCount((hideViewSelector && allQuery && Object.keys(allQuery?.q).length > 1) ? allQuery : filters);

        if (query['order']) {
            delete query['order'];
        }

        query['QueryTypeKey'] = 'ProductsAll';

        // hideViewSelector && await createFilterUrl(allQuery ?? query); --- za url query
        let result = count > 0 ? await fetchProductOverviewData((hideViewSelector && allQuery && Object.keys(allQuery?.q).length > 1) ? allQuery : filters) : [];

        if (allQuery && hideViewSelector) {
            setTableOptions({ ...tableOptions, pageSize: query['pageSize'] || 100 });
            const tableData = { data: result, page: query?.page || 0, pageSize: query['pageSize'], totalCount: count }
            setTable(tableData)
            if (filterValues.current?.fromEnter) {
                filterValues.current = { ...filterValues.current, refetch: false };
            }

            return tableData;
        }

        setTableOptions({ ...tableOptions, pageSize: query['pageSize'] || 100 });
        const tableData = { data: result, page: query?.page || 0, pageSize: query['pageSize'], totalCount: count };
        setTable(tableData)
        if (filterValues.current?.fromEnter) {
            filterValues.current = { ...filterValues.current, refetch: false };
        }

        return tableData;
        // eslint-disable-next-line
    }, [hideViewSelector, allQuery, dateRangeValue, tableRef, groupsLookup, filterValues, table, filterValues.current?.refetch]);

    let formSettings = {
        Validation: initialValues.reduce((o, k) => ({ ...o, [k]: Yup.boolean() }), {}),
        ButtonSubmit: hasPermission(permissions, "erasure_report_download") ? {
            Title: translations["download"] || "Download",
            Color: 'primary'
        } : null
    };

    const filterDataRange = async (range) => {
        dateRangeValue.From = range.From
        dateRangeValue.To = range.To
        tableRef.current && tableRef.current.onQueryChange()
    };

    const handleRefresh = () => {
        tableRef.current && tableRef.current.onQueryChange();
    }
    const tableTitle = () => {
        return <div className={classes.title}>

            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography>
                    {translations["all_assets"] || 'All assets'}
                </Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" onClick={handleRefresh}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
            <div className={classes.filters}>
                {dateRangeValue && <DataRange
                    formSettings={formSettings}
                    initialValues={dateRangeValue}
                    filterDataRange={filterDataRange}
                    value={dateRangeValue}
                    setValue={setDateRangeValue}
                    format="yyyy/MM/dd 00:00:00"
                    translations={translations}
                    minDate={moment().subtract(2, 'years')}
                />}
                {
                    hasPermission(permissions, 'erasure_report_download') ?
                        <Export
                            route={route}
                            tableRef={tableRef}
                            initialValues={initialValues}
                            formSettings={formSettings}
                            showProductOverviewExportTypes={true}
                            showProductOverviewOutputMode={true}
                            dateRangeValue={dateRangeValue}
                            exportIconTooltip={true}
                            groupsFromParent={groups}
                        /> : null
                }
            </div>
            {hasPermission(permissions, 'table_view_list') ? <TableView groupsLookup={groupsLookup} setEdited={setEdited} hideViewSelector={hideViewSelector} edited={edited} updateView={updateView} tableRef={tableRef} currentView={currentView} /> : null}
        </div>
    }

    useEffect(() => {
        if (focusedInputRef?.current) {
            document.getElementById(focusedInputRef.current).focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hideViewSelector, allQuery, dateRangeValue, tableRef, groupsLookup, filterValues, table, filterValues.current?.refetch])

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    };

    const isEdited = () => {
        if (edited) {
            setEdited(false);
        }
    };

    if (tableRef?.current) {
        const tempDragEnd = tableRef.current.onDragEnd;

        tableRef.current.onDragEnd = result => {
            tempDragEnd(result);
            tableRef.current.onDragEnd = tempDragEnd;
            isEdited();
        }
    }

    const onChangeSort = (orderedColumnId, direction) => {
        if (allQuery) {
            setQuery({ ...allQuery, orderBy: orderedColumnId, orderDirection: direction })
        }

        if (tableRef?.current?.dataManager?.orderBy && tableRef?.current?.dataManager?.orderBy !== -1) {
            tableRef.current.dataManager.orderBy = orderedColumnId;
        }
        isEdited();
    };

    const onChangeFilter = () => {
        tableRef.current && tableRef.current.onQueryChange();
    }

    return (
        <>
            <MaterialTable
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}
                data={fetchTableData}
                options={tableOptions}
                onOrderChange={onChangeSort}
                onChangeColumnHidden={isEdited}
                onQueryChange={onChangeFilter}
                localization={localization(translations)}
                components={{
                    Body: (props) => <CustomTableBody bodyProps={props} filterValues={filterValues} tableRef={tableRef} />
                }}
                onChangePage={() => { if (tableRef?.current?.tableContainerDiv?.current) { tableRef.current.tableContainerDiv.current.scrollTop = 0 } }}
            />
        </>)
}

const mapDispatchToProps = dispatch => {
    return {
        fetchProductOverviewData: filter => dispatch(actions.fetchProductOverviewData(filter)),
        fetchProductOverviewDataCount: filter => dispatch(actions.fetchProductOverviewDataCount(filter))
    };
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID || null,
        translations: state?.translate?.translations?.activeTranslations || {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ProductOverviewList));
